import { createFileRoute, Navigate } from '@tanstack/react-router'
import { Invoice } from '../../pages/Invoice'
import { invoiceBillsSearchSchema } from '../../schemas'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'

const InvoiceRoute = () => {
    const invoiceId = Route.useParams().invoiceId

    return <Invoice invoiceId={invoiceId} />
}

export const Route = createFileRoute('/_layout/invoices/$invoiceId')({
    component: () => (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>
            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <InvoiceRoute />
            </RoleRestrictedContent>
        </>
    ),
    validateSearch: invoiceBillsSearchSchema,
})
